import { Spin } from 'antd'
import styled from 'styled-components'

export const TabContentLoader = () => {
  return (
    <SLoaderContainer>
      <Spin size="large" />
    </SLoaderContainer>
  )
}

const SLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
` 